
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/matching-options",
      function () {
        return require("private-next-pages/match-booster/matching-options.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/matching-options"])
      });
    }
  